import {useMeltEntityMutation} from '../../api';
import {EntityActionFormProps} from '../common/commonTypes';
import {renderDerivationSubfields} from '../common/jsxHelpers';
import {
    meltEntityFormDefaults,
    meltEntityFormToPayload,
    meltEntityPayloadToParams,
} from './meltEntityHelpers';
import {MeltEntityFormValues} from './meltEntityTypes';
import React, {FunctionComponent, useCallback} from 'react';
import {SubmitHandler, useForm} from 'react-hook-form';
import AppModal from "../../../common/modals/AppModal";
import {useAppDispatch} from "../../../app/hooks";
import useModalType from "../../HUD/hooks/useModalType";
import {setModalType} from "../../HUD/state/HUDSlice";
import {PrependAttrFormValues} from "../prependAttribute/prependAttributeTypes";

const MeltEntityForm: FunctionComponent = () => {

    const {modalProps, closeModal} = useModalType();
	const {objectId: meltedEntityId, canEdit} = modalProps;

    const formDefaults = meltEntityFormDefaults(modalProps);

    const {
        handleSubmit,
        register,
        reset,
        resetField,
        formState
    } = useForm<MeltEntityFormValues>(
        {
            defaultValues: formDefaults,
        }
    );

    const validatingRegister = useCallback(
        (inputName: keyof MeltEntityFormValues, options?: any) =>
            register(inputName,  options ? options : {
                required: `${inputName} is required`,
            }),
        [register]
    );

    const [melt, mutationResults] = useMeltEntityMutation();

    const onSubmit: SubmitHandler<MeltEntityFormValues> = (vals, e) => {
        e?.preventDefault();
        melt(
            meltEntityPayloadToParams(
                meltEntityFormToPayload(vals),
                meltedEntityId
            )
        );
    };

    return (
        <AppModal
            label={"Melt Entity"}
            isOpen={true}
            isDirty={formState.isDirty}
            onClose={closeModal}
            onSubmit={handleSubmit(onSubmit)}
            canEdit={canEdit ? canEdit : true}>
            {renderDerivationSubfields({
                isDerivation: true,
                formState,
                resetField,
                validatingRegister,
                mutationResults
            })}

        </AppModal>
    );
};

export default MeltEntityForm;
